export default {
    title: "Cambiar contraseña",
    old_password: "Ingrese la contraseña anterior",
    new_password: "Introduzca una nueva contraseña",
    repeat_password: "Repetir nueva contraseña",
    button: "OK"
}